/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    QuestionMetadata,
    QuestionMetadataFromJSON,
    QuestionMetadataFromJSONTyped,
    QuestionMetadataToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface QuestionMetadataResponse
 */
export interface QuestionMetadataResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof QuestionMetadataResponse
     */
    msg: string;
    /**
     * 
     * @type {QuestionMetadata}
     * @memberof QuestionMetadataResponse
     */
    entry: QuestionMetadata;
}

export function QuestionMetadataResponseFromJSON(json: any): QuestionMetadataResponse {
    return QuestionMetadataResponseFromJSONTyped(json, false);
}

export function QuestionMetadataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionMetadataResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entry': QuestionMetadataFromJSON(json['entry']),
    };
}

export function QuestionMetadataResponseToJSON(value?: QuestionMetadataResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entry': QuestionMetadataToJSON(value.entry),
    };
}


